// import { REPORT_CHANNEL, ZT_ROOT_ADDRESS } from '@src/constants';
// import queryParams from '@src/utils/getAppId';
import { LANGUAGE_NAME } from '@src/utils/locale';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

export const config = {
  appId: '111111681',
  appVersion: '1.0',
  channel: 'pc',
  createCommonAttributes: () => {
    return {
      //
      language: LANGUAGE_NAME[getLanguageByPath()]
      //post_url: ZT_ROOT_ADDRESS
    };
  }
};

const gaTrackerBaseEvent = {
  // 发送埋点
  send: (event_name, event_options) => {
    // eslint-disable-next-line no-undef
    gtag('event', event_name, event_options);
  }
};

let startTimeTpl = 0;

export default function createTracker(report, getDiffRouteTime) {
  return {
    pageView: function() {
      const customEventInfo = {
        eventId: 'page_view', //事件ID
        eventDesc: '"浏览，统计总体量PV、UV需要可区分四语言（繁中、英语、日语、韩语）查看数据"', //事件描述
        eventBody: {}
      };
      report(customEventInfo);
    },
    clickDlcmsmkYoutube: function() {
      const customEventInfo = {
        eventId: 'click_dlcmsmk_youtube', //事件ID
        eventDesc: '关注我们-YouTube，需要可区分五语言（繁中、英语、日语、韩语葡萄牙语）查看数据', //事件描述
        eventBody: {}
      };
      report(customEventInfo);
      // gaTrackerBaseEvent.send('click_dlcmsmk_youtube');
    },
    clickDlcmsmkDsicord: function() {
      const customEventInfo = {
        eventId: 'click_dlcmsmk_dsicord', //事件ID
        eventDesc: '关注我们-dsicord，需要可区分五语言（繁中、英语、日语、韩语葡萄牙语）查看数据', //事件描述
        eventBody: {}
      };
      report(customEventInfo);
      // gaTrackerBaseEvent.send('click_dlcmsmk_dsicord');
    },
    clickDlcmsmkTwitter: function() {
      const customEventInfo = {
        eventId: 'click_dlcmsmk_twitter', //事件ID
        eventDesc: '关注我们-Twitter，需要可区分五语言（繁中、英语、日语、韩语葡萄牙语）查看数据', //事件描述
        eventBody: {}
      };
      report(customEventInfo);
      // gaTrackerBaseEvent.send('click_dlcmsmk_twitter');
    },
    clickDlcmsmkSteam: function() {
      const customEventInfo = {
        eventId: 'click_dlcmsmk_steam', //事件ID
        eventDesc: '点击【添加steam心愿单】，需要可区分五语言（繁中、英语、日语、韩语葡萄牙语）查看数据', //事件描述
        eventBody: {}
      };
      report(customEventInfo);
      // gaTrackerBaseEvent.send('click_dlcmsmk_steam');
    },
    clickDlcmsmkRegister: function() {
      const customEventInfo = {
        eventId: 'click_dlcmsmk_register', //事件ID
        eventDesc: '首页-测试报名，需要可区分五语言（繁中、英语、日语、韩语葡萄牙语）查看数据', //事件描述
        eventBody: {}
      };
      report(customEventInfo);
      // gaTrackerBaseEvent.send('click_dlcmsmk_register');
    },
    pageLoadDuration: function(region) {
      const endTimeTpl = new Date().getTime();
      startTimeTpl = new Date().getTime();
      const tpl = endTimeTpl - startTimeTpl;
      const customEventInfo = {
        eventId: 'page_load_duration', //事件ID
        eventDesc: '用户点进来页面loading加载时长', //事件描述
        eventBody: {
          td_pl: getDiffRouteTime(),
          region: region
        }
      };
      report(customEventInfo);
      // gaTrackerBaseEvent.send('click_start_code');
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
